import { initWhenReady, createStaticSlider } from "../../../../../themes/custom/ev_theme/frontend/js/components/sliders";
import { formState } from "../../../../../themes/custom/ev_theme/frontend/js/modules/form/FormState";
export function loadProjects(section, apiUrl, portalHref) {
    document.querySelector('.content-projects').innerHTML = '';
    let projectsLenght = 0;
    // Set to true for the section where the cards should open the
    // registration modal and not send the form directly.
    const loadModalForm = false;
    formState.manageState('openCalculator', '');
    fetch(apiUrl)
        .then(data => data.json())
        .then(data => {
        var _a, _b, _c, _d, _e;
        let projects = data.Items;
        projectsLenght = projects.length;
        if (projectsLenght > 0) {
            projects.forEach((project) => {
                var _a, _b;
                const precio = project.field_typology_price;
                const precioFormateado = new Intl.NumberFormat("es-ES", { minimumFractionDigits: 0 }).format(precio);
                const precioPorSeccion = precioFormateado.split('.');
                (_a = document.querySelector('.content-projects')) === null || _a === void 0 ? void 0 : _a.insertAdjacentHTML('beforeend', `
          <li class="splide__slide card-project card-project--results js-card-project ${project.field_project_fair ? 'fair-card' : ''} result-${project.field_node_id}">
            <div class="card-project__slider splide splide__1" id="splide${project.field_node_id}">
              <div class="splide__track">
                <ul class="splide__list">
                  <li class="splide__slide">
                    <a href="${project.field_url}" aria-label="Ir al proyecto ${project.field_name}">
                      <img loading="lazy" src="${project.field_images[0]}" alt="${project.field_type}s en venta en ${project.field_location_sector}, ${project.field_location_city}" title="${project.field_type}s en venta en ${project.field_location_sector}, ${project.field_location_city}">
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            ${project.field_project_fair ? `
              <img src="/themes/custom/ev_theme/assets/images/feria/fair-form-pennants-1.png" class="fair-card__pennants" alt="Feria Estrenar Vivienda">
              <div class="fair-card__banner">
                <p class="fair-card__banner-description">Proyecto en Feria</p>
              </div>
            ` : ''}

            <div class="card-project__content">
              <div class="card-project__features">
                <div class="card-project__features-item ev-tooltip area-basic">
                  <div class="ev-tooltip__container">
                    <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/area-icon.png" class="card-project__features-item-icon" alt="Área del inmueble"/>
                    <p class="card-project__features-item-value">${project.field_typology_area_build} m<sup>2</sup></p>
                    <span class="ev-tooltip__label"><b>?</b></span>
                    <div class="ev-tooltip__info">El valor corresponde al área construida</div>
                  </div>
                </div>
                ${project.field_alcobas ? `
                  <div class="card-project__features-item">
                    <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/bedroom-icon.png" class="card-project__features-item-icon" alt="Alcobas del inmueble"/>
                    <p class="card-project__features-item-value">${project.field_alcobas}</p>
                  </div>
                ` : ''}
                ${project.field_banos ? `
                  <div class="card-project__features-item">
                    <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/bathroom-icon.png" class="card-project__features-item-icon" alt="Baños del inmueble"/>
                    <p class="card-project__features-item-value">${project.field_banos}</p>
                  </div>
                ` : ''}
                ${(project.field_garajes !== '' && project.field_garajes !== '0' && project.field_garajes != 'Comunal') ? `
                    <div class="card-project__features-item" v-if="item.field_garajes != '' && item.field_garajes != '0' && ">
                      <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/parking-icon.png" class="card-project__features-item-icon parking" alt="Garajes del inmueble"/>
                      <p class="card-project__features-item-value">${project.field_garajes}</p>
                    </div>
                ` : ''}
                ${(project.field_garajes == 'Comunal') ? `
                    <div class="card-project__features-item ev-tooltip community-garage">
                      <img src="/themes/custom/ev_theme/assets/images/iconos_resultados_cards/parking-icon.png" class="card-project__features-item-icon parking" alt="Garajes del inmueble"/>
                      <div class="ev-tooltip__container">
                        <span class="ev-tooltip__label">
                          <b>?</b>
                        </span>
                        <div class="ev-tooltip__info">
                          Parqueadero Comunal
                        </div>
                      </div>
                    </div>
                ` : ''}
              </div>
              <h3 class="mb-0"> 
                <a href="${project.field_url}" class="card-project__title js_title_add_item_compare" aria-label="Ir al proyecto ${project.field_name}">${project.field_name}</a>

                <a href="${project.field_url}" class="card-project__location js_location_add_item_compare" aria-label="Ir al proyecto ${project.field_name}">
                  ${project.field_type}s en venta en <strong>${project.field_location_sector}, ${project.field_location_city}</strong>
                </a>

                <div class="card-project__price">
                  <p class="mb-0">
                    <label class="card-project__price-label" for="price">Desde:</label>
                    <span class="card-project__price-value js_price_add_item_compare">
                      <b class="card-project__price-value--bold">
                        <span class="card-project__price-value--currency">$</span>${precioPorSeccion[0]}.
                      </b>
                      ${precioPorSeccion.length === 3 ? `
                        <span class="card-project__price-value--text">${precioPorSeccion[1]}.${precioPorSeccion[2]}</span>
                      ` : ''}
                      ${precioPorSeccion.length === 4 ? `
                        <b class="card-project__price-value--bold">${precioPorSeccion[1]}.</b>
                        <span class="card-project__price-value--text">${precioPorSeccion[2]}.${precioPorSeccion[3]}</span>
                      ` : ''}
                    </span>
                  </p>
                  ${(project.field_tipo_de_vivienda == 11660 || project.field_tipo_de_vivienda == 11801) ? `
                    <div class="card-project__vis ev-tooltip vis-card">
                      <div class="ev-tooltip__container">
                        <div class="card-project__vis-label ev-tooltip__label">
                          ${project.field_tipo_de_vivienda == 11660 ? 'VIS' : 'VIP'}
                        </div>
                        <div class="ev-tooltip__info">Vivienda subsidiada</div>
                      </div>
                    </div>
                  ` : ''}
                </div>

              </h3>

            </div>

            <div class="card-project__footer">
              <div class="primary-btn"
                ${loadModalForm ? `onclick="projectForm('cards', ${project.field_node_id})" data-bs-toggle="modal"
                data-bs-target="#modalContacto"` : `onclick="send()"`}
                typology-name='${project.field_name}'
                typology-id='${project.field_node_id}'
                builder-number="${project.field_whatsapp}"
                data-builder-logo="${project.field_project_builder_logo}"
                builder-name="${project.field_project_builder_name}"
                typology-type='${project.field_tipo_de_vivienda}'
                typology-price='${project.field_typology_price}'
                typology-income='${project.field_required_income}'
                typology-property='${project.field_type}'
                id='formulario_card_${project.field_node_id}'
                data-post-action='simulator'
                product-ofert='${project.field_project_fair ? 3 : 1}'>
                Contactar
              </div>
            </div>
          </li>
        `);
                if (project.field_tipo_de_vivienda === 11660 || project.field_tipo_de_vivienda === 11801) {
                    (_b = document.querySelector('.content-projects' + ' .content-projects .project-card__description__price .content-tooltip--vis-cards')) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
                }
            });
        }
        if (projectsLenght == 0) {
            (_a = document.getElementById('not-results-simulator')) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
            (_b = document.getElementById('splide-simulator')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
        }
        else {
            (_c = document.getElementById('splide-simulator')) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
            (_d = document.getElementById('not-results-simulator')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
            (_e = document.getElementById('title-simulator-project')) === null || _e === void 0 ? void 0 : _e.classList.remove('d-none');
            const buttonMoreResults = document.getElementById('more-results-simulator');
            if (buttonMoreResults && data.NumItems > 4) {
                buttonMoreResults.classList.remove('d-none');
                if (portalHref) {
                    buttonMoreResults.href = portalHref;
                }
                else {
                    buttonMoreResults.href = '/proyectos-vivienda';
                }
            }
            initWhenReady(() => {
                const slider = document.querySelector('.js-splide-simulator');
                if (!slider)
                    return;
                const list = slider.querySelector('.splide__list');
                const totalItems = list ? list.children.length : 0;
                if (totalItems === 0)
                    return;
                createStaticSlider(slider, {
                    perPage: 3,
                    classes: { arrow: 'splide__arrow splide__arrow--green' },
                    breakpoints: {
                        768: { perPage: 1 },
                        600: { perPage: 1 },
                    },
                }, { lazy: true });
            });
        }
    });
}
